// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderBrown_loaderSection__dKy8e","loaderSecitionh1":"loaderBrown_loaderSecitionh1__UMWML","lds_ring":"loaderBrown_lds_ring__fPGZR"};